import React from "react";

function About() {
  return (
    <section id="about" className="py-5 bg-light-gray">
      <div className="container py-5">
        <h2 className="text-center fw-bold section-title">عني</h2>

        <div className="row align-items-center mt-5">
          <div className="col-lg-4 text-center mb-4 mb-lg-0">
            <div
              className="position-relative mx-auto"
              style={{ width: "200px", height: "200px" }}
            >
              <div
                className="bg-primary rounded-circle d-flex align-items-center justify-content-center text-white"
                style={{ width: "100%", height: "100%" }}
              >
                {/* <i className="fas fa-user fa-4x"></i> */}
                <img
                  src="/Photos/1.jpg"
                  alt="صورتي الشخصية"
                  className="img-fluid rounded-circle"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <h3 className="fw-bold mb-3">مطور ويب شامل خبير</h3>
            <p className="mb-4">
              أنا مطور ويب متكامل متخصص في إنشاء تطبيقات الويب المتكاملة
              والمواقع التفاعلية. لدي خبرة واسعة في تقنيات الواجهة الأمامية
              والخلفية على حد سواء.
            </p>
            <p className="mb-4">
              أسعى دائمًا لتقديم حلول مبتكرة تجمع بين الأداء العالي وتجربة
              المستخدم الممتازة. أستمتع بمواكبة أحدث التقنيات والعمل في بيئات
              ديناميكية.
            </p>
            <div className="d-flex flex-wrap gap-2">
              <span className="badge bg-light text-dark p-2 px-3">
                <i className="fas fa-location-dot me-2 text-primary"></i>
                اليمن: صنعاء
              </span>
              <span className="badge bg-light text-dark p-2 px-3">
                <i className="fas fa-envelope me-2 text-primary"></i>
                alaizari967@gmail.com
              </span>
              <span className="badge bg-light text-dark p-2 px-3">
                <i className="fas fa-language me-2 text-primary"></i>
                العربية، الإنجليزية
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
